import React, { useState, useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import EducationWorkProgramsBooksTable from './BooksTable/EducationWorkProgramsBooksTable';
import BookSearchForm from '../BookSearchForm';
import EducationWorkSearchItem from '../educationWorkPrograms/SearchItem';
import { BOOK_SECTIONS } from '../../utils/const';



const EducationWorkProgramsCard = ({
   fetchEducationWorkProgramsById,
   fetchEducationWorkPrograms,
   educationPrograms,
   fetchCourseBooks,
   deleteCourseBook,
   addCourseBook,
   getBooksInfo,
   booksRequest,
   searchBooks,
   booksInfo,
   location,
   books,
   loader,
  ...props
}) => {
  const [idActive, setIdActive] = useState('');

  useEffect(() => {
    fetchEducationWorkProgramsById(props.match.params.Id);
    // fetchCourseBooks(props.match.params.Id);
  }, [fetchEducationWorkPrograms, fetchCourseBooks]);

  const listFirst = [
    { name: 'Обеспечение учебной дисциплины литературой', url: 'coursebooks' },
  ];

  const goBack = () => {
  // handleBack = () => {
    const { isTeacher, history } = props      
    const { state } = history.location
    // const pathname = isTeacher ? (state?.curriculumId === 0 ? '/disprograms' : '/support_study_dis') : '/umk'
    const pathname = isTeacher ? '/disprograms' : '/support_study_dis'
    history.push({ pathname, state })    
  }

  const onCLickList = (name, id) => {
    if (id !== '') {
      setIdActive(id);
    }
  };

  const onBookSearchSubmit = (event) => {
    event.preventDefault();
    let requestBody = {
      "author": event.target.author.value,
      "bbk": event.target.bbk.value,
      "category": event.target.category.value,
      "discipline": event.target.discipline.value,
      "idclient": "",
      "isbn": event.target.isbn.value,
      "publisher": event.target.publisher.value,
      "textsearch": "",
      "title": event.target.title.value,
      "udk": event.target.udk.value,
      "verifyStatus": event.target.status.value,
      "year": event.target.year.value
    };
    searchBooks(requestBody, 0);
  };


  const onAddBook = data => {
    const idArr = books.map(i => i.library_bookid)

    if (!idArr.includes(Number(data.bookid))) {
      addCourseBook({
        courseId: props.match.params.Id,
        bookId: data.bookid,
        part: data.part
      });
    } else {
      alert("Такая книга уже есть в списке")
    }
  }
  


  const renderList = list => (
    <div className="umkT-list-div">
      {list.map((el, index) => (
        <div
          // className={idActive === el.url ? 'umkT-list-child-active' : 'umkT-list-child'} 
          className='umkT-list-child'
          style={{background: "#7b2b2a", color:"white"}}
          key={index}
          onClick={() => onCLickList(el.name, el.id || el.url)}
        >
          <span className="umkT-list-span">{el.name}</span>
        </div>
      ))}
    </div>
  );

  return (
    <div className="umkT">
      {/* <p className="caption">Рабочие программы дисциплин (модулей)</p> */}
      <div className="mb-3">
        <button className="btn" onClick={goBack}>Назад</button>
      </div>

      <div className="umkT-info-block">
        <div>
          <span>Воен.специальн.:</span>
          <span>{educationPrograms && educationPrograms['Воен.специальн.']}</span>
        </div>

        <div>
          <span>Дисциплина:</span>
          <span>{educationPrograms && educationPrograms['Дисциплина']}</span>
        </div>
        <div>
          <span>Название:</span>
          <span>{educationPrograms && educationPrograms['Название']}</span>
        </div>
        <div>
          <span>Статус:</span>
          <span>{educationPrograms && educationPrograms['Статус']}</span>
        </div>
        <div>
          <span>Учебный план:</span>
          <span>{educationPrograms && educationPrograms['Учебный план']}</span>
        </div>
      </div>
      {renderList(listFirst)}
      <div className="emkContent">
        <div>
          {books &&
          <>
            <EducationWorkProgramsBooksTable
              data={books}
              onDelete={deleteCourseBook}
              courseId={props.match.params.Id}
              getBooksInfo={getBooksInfo}
              booksInfo={booksInfo}
            />

            <h3 className='mt-3'>Добавить книги</h3>
            <BookSearchForm onSubmit={onBookSearchSubmit}/>
            {booksRequest.isLibraryDataLoading ? (
              <div className="text-center">
                <Spinner animation="border" role="status">
                  <span className="sr-only">Loading...</span>
                </Spinner>
              </div>
            ) : (
              <React.Fragment>
                {booksRequest.libraryData && booksRequest.libraryData.map((item, i) =>
                  <EducationWorkSearchItem
                    item={item}
                    bookSections={BOOK_SECTIONS}
                    onSubmit={onAddBook}
                    key={`bookSearchItem${i}`}
                  />)
                }
              </React.Fragment>
            )}
          </>
          }
        </div>
      </div>
    </div>
  );
};

export default EducationWorkProgramsCard;
